module.exports = __webpack_public_path__ + "static/img/result_desk_angle.6ad5149.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/result_desk_angle.jpg
// module id = Mm0v
// module chunks = 3